module.exports = __webpack_public_path__ + "img/official-tag.8b294ece.png";